import { Heading, Separator, Text } from "@overmap-ai/blocks"
import { memo } from "react"

import { ViewContainer } from "../../components/Containers/ViewContainer"
import { ProfileSettings } from "../../components/ProfileSettings/ProfileSettings"

export const UserProfileView = memo(() => {
	return (
		<ViewContainer maxWidth="4xl">
			<section className="flex w-full flex-col gap-4">
				<div className="flex w-full flex-col gap-1">
					<Heading size="xl">Profile</Heading>
					<Text size="sm" accentColor="base">
						Manage your profile.
					</Text>
				</div>

				<Separator size="full" />

				<ProfileSettings />
			</section>
		</ViewContainer>
	)
})
UserProfileView.displayName = "UserProfileView"
